export const signInCallback = () => {
    window.location.href = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=" +
        process.env.VUE_APP_MICROSOFT_CLIENT_ID +
        "&response_type=code&redirect_uri=" +
        process.env.VUE_APP_FRONTEND_URL +
        "redirect/microsoft&response_mode=query&scope=openid%20email%20Files.ReadWrite.All%20User.Read%20offline_access" +
        "&prompt=select_account";
};
